import React from 'react'
import { Head, router } from '@inertiajs/react'
import AdminLayout from '../../../components/AdminLayout'
import AdminTable from '../../../components/AdminTable'

interface Client {
  id: number
  name: string
  offers_count: number
  created_at: string
}

interface Props {
  clients: Client[]
  pagination: {
    current_page: number
    total_pages: number
    total_count: number
    per_page: number
    prev_page?: number
    next_page?: number
  }
  filters: {
    search?: string
  }
  can_edit: boolean
}

function ClientsIndex({ clients, pagination, filters, can_edit }: Props) {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'offers_count', label: 'Offers' },
    { key: 'created_at', label: 'Created At' },
  ]

  const formFields = [
    { name: 'name', label: 'Name', type: 'text' as const, required: true }
  ]

  const handleCreate = (formData: any) => {
    router.post('/clients', { client: formData })
  }

  const handleEdit = (item: any) => {
    const isConfirmed = window.confirm(`Are you sure you want to update the client "${item.name}"?`)
    if (isConfirmed) {
      router.put(`/clients/${item.id}`, { client: { name: item.name } })
    }
  }

  const handleDelete = (item: any) => {
    if (item.offers_count > 0) {
      alert('Cannot delete client with associated offers.')
      return
    }
    
    const isConfirmed = window.confirm(
      `Are you sure you want to delete the client "${item.name}"?\n\nThis action cannot be undone.`
    )
    if (isConfirmed) {
      router.delete(`/clients/${item.id}`)
    }
  }

  return (
    <>
      <Head title="Clients | Mailkit - Resolute" />
      <AdminTable
        title="Clients"
        description="Manage clients in the system"
        data={clients}
        columns={columns}
        pagination={pagination}
        filters={filters}
        can_edit={can_edit}
        onCreate={handleCreate}
        onEdit={handleEdit}
        onDelete={handleDelete}
        searchPlaceholder="Search clients..."
        basePath="/clients"
        formFields={formFields}
      />
    </>
  )
}

ClientsIndex.layout = page => <AdminLayout>{page}</AdminLayout>

export default ClientsIndex